import { getPageNumbersWithPhoneQuestion } from '../../Helpers/components';
import { ComponentTypes } from '../../Data/Components';
import { DYNAMIC_SELECT_AND_CONNECT_DEFAULT_MAX_BRANDS } from '../../Data/Constants';

export const isOptOut = (components) => {
  let isEmailOptOut = false;
  let isSmsOptOut = false;
  let isOttOptOut = false;

  Object.values(components).forEach((component) => {
    if (
      component?.component?.mappedQuestionId === 'sms_marketing_consent_opt_out'
    ) {
      isSmsOptOut = true;
    }
    if (
      component?.component?.mappedQuestionId === 'marketing_consent_opt_out'
    ) {
      isEmailOptOut = true;
    }
    if (
      component?.component?.mappedQuestionId === 'ott_marketing_consent_opt_out'
    ) {
      isOttOptOut = true;
    }
  });
  return { isEmailOptOut, isSmsOptOut, isOttOptOut };
};

// TODO Investigate if this legal statement is valid, and thus able to remove initial request for it
// const buildLegalStatement = (formSettings) => ({
//   consentedSuppliersHash:
//     formSettings.apiEagle.legal_statement.consented_suppliers_hash,
//   statement: formSettings.apiEagle.legal_statement.statement,
//   consentedLegalStatementHash:
//     formSettings.apiEagle.legal_statement.consented_legal_statement_hash,
//   suppliersModal: formSettings.apiEagle.legal_statement.suppliers_modal,
// });
export const isLegalStatementOnFirstPage = (components) => {
  const pageNumbersWithPhoneQuestion =
    getPageNumbersWithPhoneQuestion(components);
  return pageNumbersWithPhoneQuestion.includes(0);
};

const isDynamicNewsletter = (component) =>
  component?.component?.type === ComponentTypes.NEWSLETTER_SIGNUP &&
  component?.component?.additionalSettings?.is_dynamic;

export const isDynamicNewsletterPresent = (components) =>
  Object.values(components).some(isDynamicNewsletter);

const isDynamicSelectAndConnect = (component) =>
  component?.component?.type === ComponentTypes.SELECT_AND_CONNECT &&
  component?.component?.additionalSettings?.is_dynamic === true;

/**
 * True when a Select and Connect component on the form has its Capture
 * "dynamic" toggle on. Together with the loader feature flag this turns
 * on dynamic Select and Connect; either source alone is enough.
 */
export const isDynamicSelectAndConnectPresent = (components) =>
  Object.values(components).some(isDynamicSelectAndConnect);

/**
 * Initial features.dynamicSelectAndConnect: on with the default brand count
 * when the component toggle is on, otherwise unset so the loader flag decides.
 */
export const buildDynamicSelectAndConnectFeature = (components) => {
  if (!isDynamicSelectAndConnectPresent(components)) return null;

  return {
    enableDynamicSelectAndConnect: true,
    maxBrands: DYNAMIC_SELECT_AND_CONNECT_DEFAULT_MAX_BRANDS,
  };
};

/**
 * Parses the snapshotted strategy collection into an array. Capture delivers it
 * as a JSON-encoded string in the settings response, but re-published forms may
 * surface it as an already-decoded array, so both shapes are accepted. Anything
 * that is not a valid collection array becomes an empty array.
 */
const parseStrategyCollection = (strategyCollection) => {
  if (Array.isArray(strategyCollection)) return strategyCollection;
  if (typeof strategyCollection !== 'string') return [];

  try {
    const parsed = JSON.parse(strategyCollection);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

/**
 * Builds the form's strategy collections, snapshotted by Capture onto the form
 * and baked into the static build, indexed by subscriptionId. An absent key and
 * an empty list both mean the form has no collections.
 */
export const buildStrategyCollections = (formSettings) => {
  const collections = parseStrategyCollection(
    formSettings?.forms?.metadata?.strategyCollections
  );

  const bySubscriptionId = Object.fromEntries(
    collections
      .filter((collection) => collection?.subscriptionId)
      .map((collection) => [collection.subscriptionId, collection])
  );

  return { collections, bySubscriptionId };
};
